import { Component, computed, inject, Input, ViewChild } from '@angular/core';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataLayer } from '../../../models/data-layer';
import { Indicator } from '../../../models/indicator';
import { IndicatorData } from '../../../models/indicator-data';
import { HeaderComponent } from '../../atoms/header/header.component';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { ChipModule } from 'primeng/chip';
import { DataLayerType } from '../../../models/data-layer-type';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { GlobalsStore } from '../../../stores/globals.state';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';

@Component({
  selector: 'app-confirm-publish-data',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    HeaderComponent,
    AlertComponent,
    DividerModule,
    CheckboxModule,
    FormsModule,
    ScrollPanelModule,
    ChipModule,
  ],
  templateUrl: './confirm-publish-data.component.html',
  styleUrl: './confirm-publish-data.component.scss',
})
export class ConfirmPublishDataComponent {
  readonly dataStore = inject(IndicatorDataStore);
  readonly indicatorStore = inject(IndicatorStore);
  readonly dataLayerStore = inject(DataLayerStore);
  readonly globalsStore = inject(GlobalsStore);
  readonly confirmationDialogService = inject(ConfirmationDialogService);

  @ViewChild('cd') confirmDialog?: ConfirmDialog;

  // Inputs (from parent component) - now optional for fallback support
  @Input() dataLayerType?: DataLayerType;
  @Input() dataLayer?: DataLayer;
  @Input() indicator?: Indicator;
  @Input() indicatorData?: IndicatorData;

  // Computed fallbacks from stores (used when inputs are not provided)
  dataLayerTypeFallback = computed(() => this.globalsStore.selectedType());
  dataLayerFallback = computed(
    () =>
      this.dataLayerStore.selectedItem() || this.globalsStore.selectedLayer()
  );
  indicatorFallback = computed(
    () =>
      this.indicatorStore.selectedItem() ||
      this.globalsStore.selectedChildIndicator() ||
      this.globalsStore.selectedIndicator()
  );
  indicatorDataFallback = computed(() =>
    this.globalsStore.getActiveIndicatorData()
  );

  // Getters that use input or fallback to store
  get effectiveDataLayerType(): DataLayerType | null | undefined {
    return this.dataLayerType || this.dataLayerTypeFallback();
  }

  get effectiveDataLayer(): DataLayer | null | undefined {
    return this.dataLayer || this.dataLayerFallback();
  }

  get effectiveIndicator(): Indicator | null | undefined {
    return this.indicator || this.indicatorFallback();
  }

  get effectiveIndicatorData(): IndicatorData | null | undefined {
    return this.indicatorData || this.indicatorDataFallback();
  }

  public publishDataLayerId = false;

  onAccept(): void {
    // Store the publishDataLayerId value in the service before accepting
    this.confirmationDialogService.setPublishDataLayerId(
      this.publishDataLayerId
    );
    this.confirmDialog?.accept();
  }
}
